module.exports = __webpack_public_path__ + "img/chevron-down-gray-dark.486ef35d.svg";